module.exports = __webpack_public_path__ + "media/images/justin-new-a96c3ef8c0a2e5ea5da8634a1fa0bf2e.png";